module.exports = __webpack_public_path__ + "static/media/indegoLogo.f4a5ff6c.png";